query adMaterials($input: GetAdMaterialsInput!) {
  adMaterials(input: $input) {
    adMaterials {
      id
      url
      previewUrl
      topicName
      displayName
      imageSource
      topicId
      assetType
      createdAt
      updatedAt
    }
    filters {
      topics {
        id
        name
        count
      }
      assetTypes {
        type
        count
      }
      imageSources {
        source
        count
      }
    }
    meta {
      total
      page
      itemsPerPage
      totalPages
    }
  }
}
